import { ExportStatus } from '@/commons/enumExport.js';

const state = {
    lstNameExport: {}
};
const getters = {
    /**
     * lấy thông tin luồng xuất khẩu theo proterty
     * @param {*} state 
     * @returns 
     * created by lkphuc 09.03.2023
     */
    exportProcess: (state) => (nameFileServer) => {
        if (state.lstNameExport.hasOwnProperty(nameFileServer)) {
            // eslint-disable-next-line no-undef
            return _.cloneDeep(state.lstNameExport[nameFileServer]);
        }
        return null;
    },
};
const actions = {

};
const mutations = {

    /**
     * cập nhật trạng thái xuất khẩu thành công 
     * @param {*} state 
     * @param {*} data 
     * created by lkphuc 09.03.2023
     */
    updateSuccessStatusExportProcess(state, data) {
        let hasProcess = state.lstNameExport.hasOwnProperty(data);
        if (data && hasProcess) {
            let exportProcess = state.lstNameExport[data];
            if (exportProcess) {
                exportProcess.Status = ExportStatus.Success;
                state.lstNameExport[data] = exportProcess;
            }
        }
    },

    /**
     * cập nhật trạng thái xuất khẩu lỗi
     * @param {*} state 
     * @param {*} data 
     * created by lkphuc 09.03.2023
     */
    updateFailStatusExportProcess(state, data) {
        let hasProcess = state.lstNameExport.hasOwnProperty(data);
        if (data && hasProcess) {
            let exportProcess = state.lstNameExport[data];
            if (exportProcess) {
                exportProcess.Status = ExportStatus.Fail;
                state.lstNameExport[data] = exportProcess;
            }
        }
    },

    /**
     * thêm luồng xuất khẩu vào lstNameExport
     * @param {*} state 
     * @param {*} data 
     * created by lkphuc 09.03.2023
     */
    addExportProcess(state, data) {
        if (data && data.nameFileServer && data.nameFileClient) {
            state.lstNameExport[data.nameFileServer] = {
                NameFileClient: data.nameFileClient,
                NameFileServer: data.nameFileServer,
                Status: ExportStatus.InProcessing
            };
        }
    },

    /**
     * xóa luồng xuất khẩu 
     * @param {*} state 
     * @param {*} data 
     * created by lkphuc 13.03.2023
     */
    removeExportProcess(state, data) {
        delete state.lstNameExport[data];
    }
};

export default {
    debug: process.env.NODE_ENV !== 'production',
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};